$(document).ready(function() {

   $('.Main-slider-ps').slick({
  centerMode: true,
  arrows: false,
  infinite: true,
  dots: false,
  centerPadding: '10px',
  autoplay: true,
  autoplaySpeed: 700,
  slidesToScroll: 1,
  slidesToShow: 5,
  responsive: [
    {
      breakpoint: 480,
      settings: {
        arrows: false,
        infinite: true,
        centerMode: true,
        centerPadding: '0px',
        slidesToShow: 2
      }
    }
  ]
});

});